import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import { resolve } from '@cvent/nucleus-dynamic-css';
import DefaultStyles from '../../src/less/Icons.All.less';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var Icon = /*#__PURE__*/function (_React$Component) {
  _inherits(Icon, _React$Component);

  var _super = _createSuper(Icon);

  function Icon() {
    _classCallCheck(this, Icon);

    return _super.apply(this, arguments);
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$icon = _this$props.icon,
          icon = _this$props$icon === void 0 ? '' : _this$props$icon,
          _this$props$modifier = _this$props.modifier,
          modifier = _this$props$modifier === void 0 ? '' : _this$props$modifier,
          _this$props$classes = _this$props.classes,
          classes = _this$props$classes === void 0 ? {} : _this$props$classes,
          _this$props$iconClass = _this$props.iconClasses,
          iconClasses = _this$props$iconClass === void 0 ? DefaultStyles : _this$props$iconClass,
          fallbackText = _this$props.fallbackText,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {
        icon: null
      } : _this$props$style; // If Container is not provided in classes use default from iconClasses

      var containerClass = classes.container || iconClasses.container; // Merge default Icon classNames with modifier from imported styles //

      var iconObject = resolve({
        classes: iconClasses
      }, icon);
      var className = classNames([iconObject.className, modifier]);
      var iconInlineStyles = style.icon ? {
        style: style.icon
      } : null;
      var ariaAttr = fallbackText ? {
        'aria-label': fallbackText
      } : {
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React.createElement("span", _extends({
        className: containerClass
      }, resolveTestId(this.props)), /*#__PURE__*/React.createElement("span", _extends({
        className: className,
        role: "img"
      }, ariaAttr, iconInlineStyles)));
    }
  }]);

  return Icon;
}(React.Component);
Icon.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The name of the icon to display. */
  icon: PropTypes.string.isRequired,

  /** Text used for screen reader */
  fallbackText: PropTypes.string,

  /** Modifier className to target the Icon */
  modifier: PropTypes.string,

  /** Points to LESS/CSS file to be used for icons - defaults to imported but can be changed via this prop */
  iconClasses: PropTypes.object,

  /* Class Style Object */
  classes: PropTypes.objectOf(PropTypes.string),

  /** Available Style Keys. */
  style: PropTypes.shape({
    /** Style for the icon. */
    icon: PropTypes.object
  })
} : {};

export default Icon;
//# sourceMappingURL=index.js.map
